import { useQueryClient } from '@tanstack/react-query';
import { CreatorHubRealtimeEventName } from '@fluenceur/types';
import { useCallback } from 'react';
import { usePusher } from '@/hooks/usePusher';
import { reconcileBrandInboxRealtimeEvent } from '@/hooks/queries/conversation-cache';

interface BrandInboxRealtimeBridgeProps {
  brandId: string | null | undefined;
}

type BrandInboxEvent = {
  conversationId?: string;
  messageId?: string;
};

/** App-level subscription for Creator Hub inbox wakeups. */
const BrandInboxRealtimeBridge: React.FC<BrandInboxRealtimeBridgeProps> = ({ brandId }) => {
  const queryClient = useQueryClient();
  const handleEvent = useCallback(
    (event: BrandInboxEvent) => {
      if (!brandId || !event.conversationId) return;
      reconcileBrandInboxRealtimeEvent(queryClient, brandId, {
        conversationId: event.conversationId,
        messageId: event.messageId,
      });
    },
    [brandId, queryClient]
  );

  usePusher({
    channelName: brandId ? `private-brand-inbox-${brandId}` : '',
    eventName: CreatorHubRealtimeEventName.CONVERSATION_UPDATED,
    callback: handleEvent,
    enabled: !!brandId,
  });

  return null;
};

export default BrandInboxRealtimeBridge;
